import { axiosInstance } from '../Config/axios';

/* const API_URL = `${process.env.REACT_APP_API_URL}/api/v1/assignments/`;
const API_URL_TEMPLATE_ASSETS = `${process.env.REACT_APP_API_URL}/api/v1/assignments-template-assets/`;
const API_URL_TEMPLATE_CONTROLS = `${process.env.REACT_APP_API_URL}/api/v1/assignments-template-controls/`; */
const API_URL = 'v1/assignments/';
const API_URL_TEMPLATE_ASSETS = 'v1/assignments-template-assets/';
const API_URL_TEMPLATE_CONTROLS = 'v1/assignments-template-controls/';

// Obtener todas las asignaciones
export const getAssignments = async (params) => {
  try {
    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las asignaciones:", error);
    throw error;
  }
};

// Obtener template asignaciones para asignar controles
export const getAssignmentsAssetsTemplate = async () => {
  try {
    const response = await axiosInstance.get(API_URL_TEMPLATE_ASSETS);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las asignaciones:", error);
    throw error;
  }
};

// Obtener template asignaciones para asignar dependencias
export const getAssignmentsControlsTemplate = async () => {
  try {
    const response = await axiosInstance.get(API_URL_TEMPLATE_CONTROLS);
    return response.data;
  } catch (error) {
    console.error("Error al obtener las asignaciones:", error);
    throw error;
  }
};

// Obtener una asignación específica por código
export const getAssignmentsByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la asignación con código ${code}:`, error);
    throw error;
  }
};

// Crear una nueva asignación
export const createAssignments = async (data) => {
  try {
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error al crear la asignación:", error);
    throw error;
  }
};

// Actualizar una asignación por código
export const updateAssignments = async (code, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la asignación con código ${code}:`, error);
    throw error;
  }
};

// Eliminar una asignación por código
export const deleteAssignments = async (code) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar la asignación con código ${code}:`, error);
    throw error;
  }
};
